import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import Archive from "@/pages/Archive";
import TopicDetail from "@/pages/TopicDetail";
import Login from "@/pages/Login";
import Bookmarks from "@/pages/Bookmarks";
import MyVotes from "@/pages/MyVotes";
import NotFound from "@/pages/NotFound";
import Dashboard from "@/pages/Dashboard";

const TOASTER_OPTIONS = {
  style: {
    background: "#141414",
    border: "1px solid #333",
    borderRadius: 0,
    color: "#F5F5F5",
    fontFamily: "JetBrains Mono, monospace",
    fontSize: "0.8rem",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Archive />} />
            <Route path="/topic/:id" element={<TopicDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/bookmarks" element={<Bookmarks />} />
            <Route path="/my-votes" element={<MyVotes />} />
            <Route path="/admin" element={<Dashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" toastOptions={TOASTER_OPTIONS} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
